module.exports = __webpack_public_path__ + "static/media/simpletick_icon.31263721.svg";